import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type LookupSiteRequestPayload = {
  siteName: string
  includeFileHashes: boolean
  version: string
}

export const LookupSiteRequestPayloadSchema: CborSchema<LookupSiteRequestPayload> =
  defineCborSchema<LookupSiteRequestPayload>({
    siteName: CborField({ key: 0 }),
    includeFileHashes: CborField({ key: 1 }),
    version: CborField({ key: 2 }),
  })
